export default __webpack_public_path__ + "static/media/product_catalog_orange.438b0322.svg";